import React, { useState, useEffect } from 'react';

const ChangeTextAnimation = () => {
  const texts = [
    "ANDA AKAN MAHIR MENCUKUR RAMBUT HANYA DALAM HITUNGAN HARI MESKIPUN DARI NOL TANPA BASIC APAPUN",
    "Tenang, Kami Menyediakan Jasa Cukur Rambut Bergaransi Mengulang Seumur Hidup Dan Bisa Disalurkan Kerja",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [animation, setAnimation] = useState('enter');
  const [currentText, setCurrentText] = useState(texts[0]);
  const [nextText, setNextText] = useState('');

  useEffect(() => {
    const intervalId = setInterval(() => {
      // Start exit animation
      setAnimation('exit');
      const nextIndex = (currentIndex + 1) % texts.length;
      setNextText(texts[nextIndex]);
      
      // After exit animation, change text and start enter animation
      setTimeout(() => {
        setCurrentIndex(nextIndex);
        setCurrentText(texts[nextIndex]);
        setAnimation('enter');
      }, 500);
      
    }, 5000);

    return () => clearInterval(intervalId);
  }, [currentIndex]);

  return (
    <div className="bg-transparent flex items-center justify-center mt-10 w-full">
      <div className="bg-transpaent rounded-lg w-full">
        <div className="text-center items-center justify-center">
          <div className="h-36 overflow-hidden relative text-balance">
            {/* Current Text */}
            <p
              className={`text-5xl leading-tight text-white absolute w-full transition-all duration-500 ease-in-out
                ${animation === 'enter' ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}
            >
              {currentText}
            </p>
            {/* Next Text */}
            <p
              className={`text-5xl leading-tight text-white absolute w-full transition-all duration-500 ease-in-out
                ${animation === 'enter' ? '-translate-y-full opacity-0' : 'translate-y-0 opacity-100'}`}
            >
              {nextText}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangeTextAnimation;